export const standalonePages = [
  '/sign-login',
  '/sign-documents',
  '/engagement-login',
  '/engagement-form',
  '/pulse-survey-login',
  '/submit-pulse-survey',
] as const
